import { computed, type MaybeRef, type Ref, unref } from "vue";

interface UseBooleanFieldOptions {
  model: Ref<boolean>;
  name: MaybeRef<string | undefined>;
  checkedValue: MaybeRef<string | null | undefined>;
  defaultCheckedValue: MaybeRef<string | null>;
  uncheckedValue: MaybeRef<string | null | undefined>;
}

export const useBooleanField = ({
  model,
  name,
  checkedValue,
  defaultCheckedValue,
  uncheckedValue,
}: UseBooleanFieldOptions) => {
  const isChecked = computed(() => model.value === true);

  const checkedSubmitValue = computed(() => unref(checkedValue) ?? unref(defaultCheckedValue));

  const shouldRenderUncheckedInput = computed(() => {
    const value = unref(uncheckedValue);
    return !!unref(name) && value !== undefined && value !== null;
  });

  const onToggle = (event: Event) => {
    model.value = (event.target as HTMLInputElement).checked;
  };

  return {
    isChecked,
    checkedSubmitValue,
    shouldRenderUncheckedInput,
    onToggle,
  };
};
